import React, { useEffect, useRef, useState } from "react";
import api from "../../api/config";
import { useLoadScript } from "@react-google-maps/api";
import PlacesAutocomplete from "./AddressAutoComplete";
import { PROVIDER_SIDEBAR_MENUS } from "../../constants/constants";
import { validateBasicPropertyDetails } from "../../validators/providers/AddBusiness";
import { useFormContext } from "../../context/FormContext";

const PropertyBasicForm = ({
  setActiveMenu,
  providerDetail,
  params,
  loading,
  temp,
  setTemp,
}) => {
  const { formData, setFormData } = useFormContext();
  const initialAddress = formData?.propertyBasic;
  console.log(initialAddress, 'init')
  const [propertyTypeList, setPropertyTypeList] = useState([]);
  const [loadingPropertyType, setLoadingPropertyType] = useState(false);
  const [selectedCategoryID, setSelectedCategoryID] = useState(
    formData?.propertyBasic?.categoryId || null
  );
  // Create refs for the input fields
  const categoryRef = useRef(null);
  const propertyNameRef = useRef(null);
  const streetAddressRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  console.log(providerDetail, "providerDetail");
  console.log(formData, "formData");

  useEffect(() => {
    if (params?.type !== "new" && !temp) {
      if (!!Object.values(providerDetail).length) {
        setTemp(true);
        console.log(Object.values(providerDetail).length, "first");
        setSelectedCategoryID(providerDetail?.categoryId);
        setPropertyName(providerDetail?.name);
        /*
        setAddress({
          ...address,
          street: providerDetail?.address1,
          city: providerDetail?.city,
          state: providerDetail?.state,
          pin: providerDetail?.pin,
        });
        */
        setFormData((prev) => ({
          ...prev,
          propertyBasic: {
            ...prev.propertyBasic,
            address1: providerDetail?.address1,
            address2: providerDetail?.address2,
            city: providerDetail?.city,
            state: providerDetail?.state,
            pin: providerDetail?.pin,
            latitude: providerDetail?.latitude,
            longitude: providerDetail?.longitude,
          },
        }));
        setAddress2(providerDetail?.address2);
        setSelected({
          ...selected,
          lat: providerDetail?.latitude,
          lng: providerDetail?.longitude,
        });
      }
    }
  }, [loading]);
/*
  const [address, setAddress] = useState(
    {
      street: initialAddress?.street ? initialAddress?.street : initialAddress?.address1 ,
      city: initialAddress?.city,
      state: initialAddress?.state,
      pin: initialAddress?.pin,
    } || null
  );
*/
  const [selected, setSelected] = useState(null);
  const [propertyName, setPropertyName] = useState(
    formData?.propertyBasic?.name || ""
  );
  const [address2, setAddress2] = useState(
    formData?.propertyBasic?.address2 || ""
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    category: "",
    propertyName: "",
    streetAddress: "",
    city: "",
    state: "",
  });

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCmYRzM9CMuVD0C0xkQP6Vt9VyVcfMKQ2o",
    libraries: ["places"],
  });

  const handleChange = (e) => {
    setPropertyName(e.target.value);
  };

  const handleChangeAddress = (e) => {
    setAddress2(e.target.value);
  };

  const fetchCategories = async () => {
    setLoadingPropertyType(true);
    try {
      const propertyCategory = await api.get("/property-category");
      setPropertyTypeList(propertyCategory.data.response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingPropertyType(false);
    }
  };

  const fetchSubCategories = async () => {
    let propertySubCategory;
    try {
      if (selectedCategoryID) {
        if (selectedCategoryID) {
          propertySubCategory = await api.get(
            `/property-sub-category/${selectedCategoryID}`
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCategoryChange = (event) => {
    setSelectedCategoryID(event.target.value);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchSubCategories();
  }, [selectedCategoryID]);

  useEffect(() => {
    if (isSubmitting) {
      validateForm();
    }
  }, [
    isSubmitting,
    selectedCategoryID,
    propertyName,
    formData.propertyBasic.address1,
    formData.propertyBasic.city,
    formData.propertyBasic.state
  ]);
  //}, [selectedCategoryID, propertyName, formData.propertyBasic.address1, formData.propertyBasic.city, formData.propertyBasic.state]);
  //}, [selectedCategoryID, address, propertyName]);

  const validateForm = () => {
    /*
    const newErrors = {
      category: validateBasicPropertyDetails(selectedCategoryID, "category"),
      propertyName: validateBasicPropertyDetails(propertyName, "propertyName"),
      streetAddress: validateBasicPropertyDetails(
        address?.street,
        "streetAddress"
      ),
      city: validateBasicPropertyDetails(address?.city, "city"),
      state: validateBasicPropertyDetails(address?.state, "state"),
      */
      const newErrors = {
        category: validateBasicPropertyDetails(selectedCategoryID, "category"),
        propertyName: validateBasicPropertyDetails(propertyName, "propertyName"),
        streetAddress: validateBasicPropertyDetails(
          formData.propertyBasic.address1,
          "streetAddress"
        ),
        city: validateBasicPropertyDetails(
          formData.propertyBasic.city,
          "city"
        ),
        state: validateBasicPropertyDetails(
          formData.propertyBasic.state,
          "state"
        ),
      };
    
    setErrors(newErrors);

    const firstErrorField = Object.keys(newErrors).find(
      (key) => newErrors[key] !== ""
    );
   
    // Scroll to the first error field
    if (firstErrorField) {
      switch (firstErrorField) {
        case "category":
          categoryRef.current.scrollIntoView({ behavior: "smooth" ,block: 'end' });
          break;
        case "propertyName":
          propertyNameRef.current.scrollIntoView({ behavior: "smooth",block: 'end'});
          break;
        case "streetAddress":
          streetAddressRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "city":
          cityRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        case "state":
          stateRef.current.scrollIntoView({ behavior: "smooth" });
          break;
        default:
          break;
      }
    }


    return Object.values(newErrors).every((error) => error === "");
  };
/*
  const handleSubmit = () => {
    setIsSubmitting(true);
    const isFormValid = validateForm();
    if (isFormValid) {
      setIsSubmitting(false);
      setFormData({
        ...formData,
        propertyBasic: {
          categoryId: selectedCategoryID,
          name: propertyName,
          address1: address?.street,
          address2: address2,
          city: address?.city,
          state: address?.state,
          pin: address?.pin,
          latitude: selected?.lat ? selected?.lat : formData?.propertyBasic?.latitude,
          longitude: selected?.lng ? selected?.lng : formData?.propertyBasic?.longitude,
        },
      });
      setActiveMenu(PROVIDER_SIDEBAR_MENUS.PROPERTY_DESCRIPTION);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
    }
  };
*/
  const handleSubmit = () => {
    setIsSubmitting(true);
    const isFormValid = validateForm();

    if (isFormValid) {
      setIsSubmitting(false);

      setFormData((prev) => ({
        ...prev,
        propertyBasic: {
          ...prev.propertyBasic,
          categoryId: selectedCategoryID,
          name: propertyName,
          address1: prev.propertyBasic.address1,
          address2: prev.propertyBasic.address2,
          city: prev.propertyBasic.city,
          state: prev.propertyBasic.state,
          pin: prev.propertyBasic.pin,
          latitude: selected?.lat
            ? selected.lat
            : prev.propertyBasic.latitude,
          longitude: selected?.lng
            ? selected.lng
            : prev.propertyBasic.longitude,
        },
      }));

      setActiveMenu(PROVIDER_SIDEBAR_MENUS.PROPERTY_DESCRIPTION);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  //console.log(address,"addredd",formData)
  console.log(formData.propertyBasic, "propertyBasic", formData);
  return (
    <>
{/*    
      <div className="col-md-9 ">
        <div className="m-5">
          <div className="card">
            <div className="card-body pb-0">
              <div className="form-group" ref={categoryRef}>
                <label className="form-label" for="formGroupExampleInput">
                  Property Type<span className="text-danger">*</span>
                </label>
                <select
                  disabled={loadingPropertyType ? true : false}
                  className="form-select"
                  value={selectedCategoryID}
                  onChange={handleCategoryChange}
                  
                >
                  <option value="">Select</option>
                  {propertyTypeList.map((item) => (
                    <option key={item.categoryId} value={item.categoryId}>
                      {item.category}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <div className="text-danger">{errors.category}</div>
                )}
              </div>
              <div className="form-group" ref={propertyNameRef}>
                <label className="form-label" for="formGroupExampleInput2">
                  Property Name<span className="text-danger">*</span>
                </label>
                <input
                  onChange={handleChange}
                  value={propertyName}
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput2"
                  placeholder="Property Name"
                />
                {errors.propertyName && (
                  <div className="text-danger">{errors.propertyName}</div>
                )}
              </div>
              <label
                className="mt-4 form-label-heading"
                for="formGroupExampleInput"
              >
                Address
              </label>
            </div>
            <hr className="mr-0" />
            <div className="card-body pt-0">
              <div className="form-group" ref={streetAddressRef}>
                <label className="form-label" for="formGroupExampleInput2">
                  Street Address<span className="text-danger">*</span>
                </label>
                <PlacesAutocomplete
                  isLoaded={isLoaded}
                  setFormData={setAddress}
                  setSelected={setSelected}
                />
                {errors.streetAddress && (
                  <div className="text-danger">{errors.streetAddress}</div>
                )}
              </div>
              <div className="row">
                <div className="form-group col-md-5">
                  <label className="form-label" for="streetaddress2">
                    Street Address Line 2
                  </label>
                  <input
                    type="text"
                    value={address2}
                    onChange={handleChangeAddress}
                    className="form-control"
                    id="streetaddress2"
                    placeholder="Street Address 2"
                  />
                </div>
                <div className="form-group col-md-5" >
                  <label className="form-label" for="zipcode">
                    Zipcode
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="zipcode"
                    readOnly
                    value={address?.pin}
                    placeholder="Zipcode"
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-5" ref={cityRef}>
                  <label className="form-label" for="city">
                    City<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={address?.city}
                    className="form-control"
                    id="city"
                    placeholder="City"
                  />
                  {errors.city && (
                    <div className="text-danger">{errors.city}</div>
                  )}
                </div>
                <div className="form-group col-md-5" ref={stateRef}>
                  <label className="form-label" for="state">
                    State<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readOnly
                    value={address?.state}
                    className="form-control"
                    id="state"
                    placeholder="State"
                  />
                  {errors.state && (
                    <div className="text-danger">{errors.state}</div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="mt-3 primary-btn"
                onClick={handleSubmit}
              >
                Next
              </button>
              
              </div>
              </div>
            </div>
          </div>
        </div>
*/}      
        <div className="col-md-9 ">
          <div className="m-5">
            <div className="card">
              <div className="card-body pb-0">

                {/* PROPERTY TYPE */}
                <div className="form-group" ref={categoryRef}>
                  <label className="form-label">Property Type<span className="text-danger">*</span></label>
                  <select
                    disabled={loadingPropertyType}
                    className="form-select"
                    value={selectedCategoryID}
                    onChange={handleCategoryChange}
                  >
                    <option value="">Select</option>
                    {propertyTypeList.map((item) => (
                      <option key={item.categoryId} value={item.categoryId}>
                        {item.category}
                      </option>
                    ))}
                  </select>
                  {errors.category && <div className="text-danger">{errors.category}</div>}
                </div>

                {/* PROPERTY NAME */}
                <div className="form-group" ref={propertyNameRef}>
                  <label className="form-label">Property Name<span className="text-danger">*</span></label>
                  <input
                    onChange={handleChange}
                    value={propertyName}
                    type="text"
                    className="form-control"
                    placeholder="Property Name"
                  />
                  {errors.propertyName && <div className="text-danger">{errors.propertyName}</div>}
                </div>

                <label className="mt-4 form-label-heading">Address</label>
              </div>

              <hr className="mr-0" />

              <div className="card-body pt-0">

                {/* STREET ADDRESS (AUTOCOMPLETE) */}
                <div className="form-group" ref={streetAddressRef}>
                  <label className="form-label">Street Address<span className="text-danger">*</span></label>
                  
                  <PlacesAutocomplete
                    isLoaded={isLoaded}
                    setFormData={(updated) =>
                      setFormData((prev) => ({
                        ...prev,
                        propertyBasic: {
                          ...prev.propertyBasic,
                          ...updated,
                        },
                      }))
                    }
                    setSelected={setSelected}
                  />

                  {errors.streetAddress && <div className="text-danger">{errors.streetAddress}</div>}
                </div>

                <div className="row">

                  {/* STREET ADDRESS LINE 2 */}
                  <div className="form-group col-md-5">
                    <label className="form-label">Street Address Line 2</label>
                    <input
                      type="text"
                      value={formData.propertyBasic.address2 || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          propertyBasic: {
                            ...prev.propertyBasic,
                            address2: e.target.value,
                          },
                        }))
                      }
                      className="form-control"
                      placeholder="Street Address 2"
                    />
                  </div>

                  {/* ZIPCODE */}
                  <div className="form-group col-md-5">
                    <label className="form-label">Zipcode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.propertyBasic.pin || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          propertyBasic: {
                            ...prev.propertyBasic,
                            pin: e.target.value,
                          },
                        }))
                      }
                      placeholder="Zipcode"
                    />
                  </div>
                </div>

                <div className="row">

                  {/* CITY */}
                  <div className="form-group col-md-5" ref={cityRef}>
                    <label className="form-label">City<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      value={formData.propertyBasic.city || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          propertyBasic: {
                            ...prev.propertyBasic,
                            city: e.target.value,
                          },
                        }))
                      }
                      className="form-control"
                      placeholder="City"
                    />
                    {errors.city && <div className="text-danger">{errors.city}</div>}
                  </div>

                  {/* STATE */}
                  <div className="form-group col-md-5" ref={stateRef}>
                    <label className="form-label">State<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      value={formData.propertyBasic.state || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          propertyBasic: {
                            ...prev.propertyBasic,
                            state: e.target.value,
                          },
                        }))
                      }
                      className="form-control"
                      placeholder="State"
                    />
                    {errors.state && <div className="text-danger">{errors.state}</div>}
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    className="mt-3 primary-btn"
                    onClick={handleSubmit}
                  >
                    Next
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default PropertyBasicForm;
